'use strict';

module.exports = {
  DraftPage: require('../pages/DraftPage'),
  DraftPreviewPage: require('../pages/DraftPreviewPage'),
  DraftComposePage: require('../pages/DraftComposePage')
};


/** WEBPACK FOOTER **
 ** ./chunks/editor.js
 **/